export class UserUrl {
    public static get GET_APP_ACTIVE_LINK_URL(): string { return '/active-link'; }

    public static get GET_LOGIN_ULR(): string { return '/connect/authorize'; }
    public static get GET_CENTRE_USERS(): string { return "/api/centre/users"; }
    public static get GET_USER_CENTRES(): string { return '/api/user/centre'; }
    public static get GET_USER_COUNTRY(): string { return "/api/user/country"; }
    public static get GET_COUNTRIES_HAS_CENTRE(): string { return '/api/centre/countries'; }
    public static get GET_ROLES(): string { return "/api/user/roles"; }
    public static get GET_USER_COUNTRY_INIT(): string { return "/api/user/countryRegister"; }
    public static get VALIDATE_MYTMB(): string { return "/Account/ValidateMyTMBAccount"; }
    public static get CHECK_TMB_USER(): string { return "/api/Patient/myaccount/check-tmb-user"; }


    public static get GET_UNASSIGNED_CENTRE_USERS(): string { return "/api/centre/users/unassigned"; }
    public static get REMOVE_CENTRE_USER(): string { return "/api/centre/user/{userId}/delete"; }
    public static get ASSIGN_CENTRE_USER(): string { return "/api/centre/user/{userId}/assign/{roleId}"; }
    public static get GET_USER_PERMISSION(): string { return "/api/user/GetPermissions"; }
    public static get CHANGE_PASSWORD(): string { return "/api/user/UpdatePassword"; }
    public static get CREATE_PASSWORD(): string { return "/api/user/CreatePassword"; }

    public static get CREATE_NEW_USER_URL(): string { return '/api/user/createNewUser'; }
    public static get EMAIL_CONFIRM_URL(): string { return '/api/user/EmailConfirm'; }
    public static get RESEND_CONFIRM_EMAIL_URL(): string { return '/api/user/ResendEmail'; }

    public static get GET_VACCINES(): string { return '/api/Batch/GetAllVaccine'; }
    public static get GET_BATCHS(): string { return '/api/Batch/GetBatch'; }

    public static get GET_ALL_URL(): string { return '/api/user'; }
    public static get REGISTER_URL(): string { return '/api/account/register'; }
    public static get CHANGE_USER_STATUS(): string { return '/api/user/{id}/changestatus/{status}' }
    public static get UPLOAD_AVATAR_URL(): string { return '/api/user/uploadavatar'; }
    public static get LOAD_AVATAR_URL(): string { return '/Upload'; }
    public static get ASSIGN_TO_ROLE(): string { return '/api/user/AddToRoles?userid='; }
    public static get UPDATE_LASTlOGIN(): string { return '/api/user/updatelastlogin?userName='; }
    public static get RESET_PASSWORD(): string { return '/api/Account/ResetPassword'; }
    public static get CHECK_CHANGE_PASSWORD_NEXT_LOGIN(): string { return '/api/user/CheckChangePasswordNextLogin?userName='; }
    public static get GET_USER_URL(): string { return '/api/user'; }
    public static get FORGET_PASSWORD(): string { return '/api/Account/ForgotPassword'; }
    public static get UPDATE_PROFILE(): string { return '/api/user/updateprofile'; }
    public static get GET_PROFILE(): string { return '/api/user/getprofile'; }
    public static get GET_PERMISSION(): string { return '/api/Account/GetPermission?'; }
    public static get GET_ROLE_BY_USERID(): string { return '/api/user/GetRoles?userId='; }

    public static get WRITE_AUDIT_LOG_OUT(): string { return '/api/Account/Audittrail'; }


}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/urls/user.url.ts